import { changeStyleClass, toElements, type TElementSpecifier } from "@de-xima/xima-common-js-dom";
import { withIndex } from "@de-xima/xima-common-js-lang";

/**
 * Finds the first element with the given class name, if any.
 * @deprecated TODO: Move this to @de-xima/xima-common-js-dom
 * @param className CSS class name to search for.
 * @returns First element with the given class name, if any.
 */
export function byCssClass(className: string): Element | undefined {
  return document.getElementsByClassName(className)[0] ?? undefined;
}

/**
 * Toggles between two different, alternative styles classes. For example, if classes `x`
 * and `y` are given: If the element currently has `x`, removes `x` and adds `y`;
 * otherwise removes `y` and add `x`.
 *
 * In case of conflicts (element has both classes or neither class), the presence
 * or absence of the first given class is given priority. After this method completes,
 * exactly one of the two given classes is present on the element.
 * @param elements Elements to change.
 * @param class1 First style class.
 * @param class2 Second style class.
 */
export function toggleBetweenClasses(elements: TElementSpecifier<Element>, class1: string, class2: string): void {
  for (const element of toElements(elements)) {
    const hasClass1 = element.classList.contains(class1);
    changeStyleClasses(element, [class1, class2], [hasClass1 ? 1 : 0]);
  }
}

/**
 * Adds or removes a list of style classes from all given elements. For each class
 * in the given list, the classes at the given indices are added, and all other classes
 * are removed.
 * @param selector
 * @param classes CSS classes to add or remove.
 * @param indices Indices of the classes to add, all other classes are removed.
 */
function changeStyleClasses(
  selector: TElementSpecifier<Element>,
  classes: readonly string[],
  indices: readonly number[],
): void {
  for (const element of toElements(selector)) {
    for (const [cssClass, i] of withIndex(classes)) {
      changeStyleClass(element, cssClass, indices.indexOf(i) >= 0);
    }
  }
}
